<template>
  <div class="app-page__container">
    <div v-if="!isLoading">
      <div class="teams__title__container">
        <h5 class="title is-5">
          {{ `${activeWorkspace.workspaceName} Teams`}}
        </h5>
        <div class="teams__title__end">
          <b-button
            v-if="isLoggedInUserWorkspaceOwner"
            type="is-info"
            icon-left="plus"
            size="is-small"
            @click.prevent="handleClickCreateTeam"
          >
            Create Team
          </b-button>
        </div>
      </div>
      <div class="card">
        <div class="card-content">
          <div
            v-for="team in Object.values(teams)"
            :key="team.id"
            :class="[
              'teams__team-details__container',
            ]"
          >
            <div>
              <span class="has-text-weight-bold">
                {{ team.teamName }}
              </span>
              &nbsp;
              <span class="is-size-7">
                {{ team.userIds.length }}
                {{ `Member${team.userIds.length === 1 ? '' : 's'}` }}
              </span>
            </div>
            <div>
              <BButton
                type="is-info"
                outlined
                size="is-small"
                icon-left="cog"
                @click.prevent="handleClickTeamDetails(team.id)"
                @keyup.enter="handleClickTeamDetails(team.id)"
              >
                Team Settings
              </BButton>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else style="position: relative; min-height: 150px;">
      <b-loading :is-full-page="false" :active.sync="isLoading" :can-cancel="false"></b-loading>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import * as TeamActions from '@/store/actions/Team.actions';

export default {
  name: 'TeamsView',

  data() {
    return {
      areWorkspaceTeamsLoading: true,
    };
  },

  computed: {
    ...mapState({
      activeWorkspaceId: state => state.workspace.activeWorkspaceId,
      teams: state => state.team.teams,
    }),
    ...mapGetters([
      'activeWorkspace',
      'loggedInUser',
      'isLoggedInUserWorkspaceOwner',
    ]),
    isLoading() {
      return this.areWorkspaceTeamsLoading;
    },
  },

  created() {
    this.fetchInitialData();
  },

  methods: {
    ...mapActions({
      fetchPublicWorkspaceTeams: TeamActions.FETCH_PUBLIC_WORKSPACE_TEAMS,
      fetchUserTeams: TeamActions.FETCH_USER_TEAMS,
    }),
    handleClickCreateTeam() {
      this.$router.push('/create-team');
    },
    handleClickTeamDetails(teamId) {
      this.$router.push(`/teams/edit/${teamId}`);
    },
    async fetchInitialData() {
      try {
        await Promise.all([
          this.fetchPublicWorkspaceTeams({ workspaceId: this.activeWorkspaceId }),
          this.fetchUserTeams({ userId: this.loggedInUser.id, workspaceId: this.activeWorkspace.id }),
        ]);

        this.areWorkspaceTeamsLoading = false;
      } catch (err) {
        console.error(err); // eslint-disable-line no-console
      }
    },
  },
};
</script>

<style scoped lang="scss">
.teams__title__container {
  display: flex;
  justify-content: space-between;
}

.teams__title__end {
  align-items: flex-end;
}

.teams__team-details__container {
  display: flex;
  justify-content: space-between;
  padding: $global-whitespace-small;

  &:hover {
    background-color: $white-bis;
  }
}

.teams__team-details__container--clickable {
  cursor: pointer;

  &:hover {
    border-left: 2px solid $info;
    margin-left: -2px;
  }
}
</style>
